module.exports = __webpack_public_path__ + "img/mine-menu12.ce54d770.png";